/**
 * Normalizes vendor sizing chart list payloads from GET vendor/sizingcharts
 * (handles multiple backend wrapper shapes — same rules as SizingCharts page).
 */

export function toArrayPayload(payload) {
  if (Array.isArray(payload)) return payload;
  if (
    payload &&
    typeof payload === "object" &&
    (payload.chartName || payload.brandId || payload.id) &&
    Array.isArray(payload.items)
  ) {
    return [payload];
  }
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.sizingCharts)) return payload.sizingCharts;
  if (Array.isArray(payload?.value)) return payload.value;
  if (
    payload &&
    typeof payload === "object" &&
    (payload.chartName ||
      payload.ChartName ||
      payload.brandId ||
      payload.BrandId ||
      payload.id ||
      payload.Id)
  ) {
    return [payload];
  }
  return [];
}

export function extractChartList(payload) {
  const direct = toArrayPayload(payload);
  if (direct.length) return direct;

  const nested = [
    payload?.data?.items,
    payload?.data?.results,
    payload?.data?.sizingCharts,
    payload?.data?.value,
    payload?.result?.items,
    payload?.result?.results,
  ].find((x) => Array.isArray(x));

  return Array.isArray(nested) ? nested : [];
}

export function normalizeChart(row) {
  if (!row) return null;
  const rowItems = Array.isArray(row.items)
    ? row.items
    : Array.isArray(row.Items)
      ? row.Items
      : [];
  const firstItem = rowItems[0] || null;
  const fallbackSizes = Array.isArray(row.sizes) ? row.sizes : [];
  const rowId =
    row.id ??
    row.Id ??
    row.chartId ??
    row.ChartId ??
    firstItem?.id ??
    firstItem?.Id ??
    null;
  return {
    id: rowId,
    chartName:
      row.chartName ||
      row.ChartName ||
      row.name ||
      row.Name ||
      "Sizing chart",
    brandId: row.brandId ?? row.BrandId,
    unit: row.unit ?? row.Unit,
    items: rowItems,
    sizes: firstItem?.sizes || firstItem?.Sizes || fallbackSizes,
    gender: row.gender ?? row.Gender ?? "—",
  };
}

/** Maps vendor brand API rows (camelCase or PascalCase) to { id, name }. */
export function normalizeVendorBrandRow(b) {
  if (!b || typeof b !== "object") return null;
  const rawId = b.id ?? b.Id;
  if (rawId == null || rawId === "") return null;
  return {
    id: String(rawId),
    name: String(b.name ?? b.Name ?? "").trim() || "Brand",
  };
}

export function getNormalizedVendorBrands(rawBrands) {
  return toArrayPayload(rawBrands)
    .map(normalizeVendorBrandRow)
    .filter(Boolean);
}

export function getNormalizedVendorSizingCharts(rawCharts) {
  return extractChartList(rawCharts)
    .map(normalizeChart)
    .filter((c) => Boolean(c && (c.id || c.chartName)));
}

export function getProductSizingChartNameFromRow(row) {
  if (!row || typeof row !== "object") return "";
  return (
    row.vendorSizingChartName ??
    ""
  );
}

export function getProductSizeFromRow(row) {
  if (!row || typeof row !== "object") return "";
  return row.size ?? "";
}
